import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch, useHistory } from "react-router-dom";
import { setPageClass, setUpHeader } from "../../store/features/slice-ui";
import { addBulkFavourites } from "../../store/features/slice-account";
import parse from 'html-react-parser';
import PageHead from "../../components/PageHead";
import PageContent from "../../components/PageContent";
import Cta from "../../components/Cards/Cta";
import { Word } from '../../components/Word';
import HorizontalScroller from '../../components/HorizontalScroller';
import FavDoctorCard from "../../components/Cards/DoctorCircular";
import Button from "../../components/Button";
import Select from '../../components/Form/Select';

import G from "../../app/globals";
import { ReactComponent as DoctorIcon } from '../../assets/images/icons/doctor.svg';
import { ReactComponent as LocationIcon } from '../../assets/images/icons/location.svg';
import { ReactComponent as ScopeIcon } from '../../assets/images/icons/s_scope.svg';
import { ReactComponent as ClosestIcon } from '../../assets/images/icons/closest_location.svg';
import { ReactComponent as CheckedSolidIcon } from '../../assets/images/icons/check_solid.svg';


const ReferPatientIndex = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch();
  const [successMessage, setSuccessMessage] = useState("");
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const accountData = useSelector((state) => state.account.data);
  const doctorsListBasic = useSelector((state) => state.doctors.basic);
  const options = useSelector((state) => state.references.options);
  useEffect(() => {
    dispatch(setPageClass("page-refer-patient"));
    dispatch(setUpHeader({
      show: true,
      logo: true,
      back: false,
      profile: true,
      search: true
    }));
  }, [dispatch]);

  useEffect(() => {
    if(accountData){
      //Remove Foxo Integration
    //   if(accountData.foxoId && accountData.foxoStatus === 'is_synced'){
    //     if(options && options.static_texts && options.static_texts.submit_ref_message_hasfoxo){
    //       setSuccessMessage(parse(options.static_texts.submit_ref_message_hasfoxo, G.HTML_PARSE_OPTIONS))
    //     }
    //     else{
    //       setSuccessMessage(G.DEFAULT_SUBMIT_REF_MSG);
    //     }
    //  }
      // else{
        if(options && options.static_texts && options.static_texts.submit_ref_message_nofoxo){
          setSuccessMessage(parse(options.static_texts.submit_ref_message_nofoxo, G.HTML_PARSE_OPTIONS))
        }
        else{
          setSuccessMessage(G.DEFAULT_SUBMIT_REF_MSG);
        }
      // }
    }

  }, [dispatch, accountData, options]);

  const renderFavDoctorsCards = () => {
    return accountData && accountData.favourites && doctorsListBasic ? accountData.favourites.map(id => (
      doctorsListBasic[id] ? 
        <FavDoctorCard
            key={id}
            slug={doctorsListBasic[id].slug}
            image={doctorsListBasic[id].profileImage}
            title={parse(doctorsListBasic[id].salutation+" "+doctorsListBasic[id].name)}
            link={`/refer-patient/doctor/${doctorsListBasic[id].slug}`}
        /> : null
    )) : null;
  };


  const handleAddFavourite = () => {
    dispatch(addBulkFavourites({doctors: [props.location.state.doctor]})).then(e => {
      history.replace('/account/favourites')
    })
  }

  const handleDoctorSelectChange = (payload) => {
    history.push(`/refer-patient/doctor/${payload.value}`)
  }

  const handleDownloadPdf = () => {
    G.BASE64_TO_DOWNLOAD_FILE(props.location.state.file, {parent: 'ida', type: 'referral', id: 'confirmation'});
  }
  
  return (
    <>
      <PageHead 
        className="page-refer-patient--page-head"
        title="Refer a Patient"
        bg="blue"
      />
      {props.location.state && props.location.state.source && props.location.state.source === 'formsubmission' ? 
        <div className="success--message">
          <div className="success--message-icon"><CheckedSolidIcon /></div>
          {successMessage}

          {props.location.state.file &&
          <Button
                  type={"button"}
                  className="btn-primary text-yellow"
                  text="Download referral confirmation"
                  Clicked={handleDownloadPdf}
                />
          }

          {props.location.state.doctor && accountData && accountData.favourites && !accountData.favourites.includes(props.location.state.doctor) && doctorsListBasic ? 
        
            doctorsListBasic[props.location.state.doctor] ? 
              <>
                <FavDoctorCard
                    slug={doctorsListBasic[props.location.state.doctor].slug}
                    image={doctorsListBasic[props.location.state.doctor].profileImage}
                    title={parse(doctorsListBasic[props.location.state.doctor].salutation+" "+doctorsListBasic[props.location.state.doctor].name)}
                    link={`/doctor/${doctorsListBasic[props.location.state.doctor].slug}`}
                />
                <Button
                  type={"button"}
                  className="btn-primary text-yellow"
                  text="Add as favourite"
                  Clicked={handleAddFavourite}
                />
              </>
              : null
          : null}
          <h3>Need to refer another patient?</h3>
        </div>
      : null}
      <PageContent className="page-refer-patient--page-content">
         <div className="page-find-doctor--ops">
          {accountData && accountData.favourites.length > 0 ? 
            <div className="page-find-doctor--favourites">
              <h2><Word value="Your favourites" /></h2>
              <HorizontalScroller scrollOffset={180}>
                {renderFavDoctorsCards()}
              </HorizontalScroller>
            </div>
          : null}
          <div className="page-find-doctor--quick-search">
          {doctorsListBasic && Object.values(doctorsListBasic).length > 0 ? 
             <>
                <h2><Word value="Quick search" /></h2>
                <Select 
                  name={'doctor_name'}
                  id={'doctor_name'}
                  options={Object.values(doctorsListBasic).map(item => ({ 'value': item['slug'], 'label': parse(item['name']) }))}
                  onChange={handleDoctorSelectChange}
                />
              </>
            : null}
          </div>
        </div>
        <div className="page-refer-patient--ctas">
          <Cta 
            title={<Word value="Refer by Centre" />}
            subtitle="Find a Icon Specialist by location or centre"
            icon="chevron_right"
            iconBg="blue"
            svg={<LocationIcon />}
            svgBg="purple"
            isCentered
            isBordered
            link={`${match.url}/centre`}
          />
          <Cta 
            title={<Word value="Refer by Doctor" />}
            subtitle="Find a Doctor by name"
            icon="chevron_right"
            iconBg="blue"
            svg={<ScopeIcon />}
            svgBg="yellow"
            isCentered
            isBordered
            link={`${match.url}/doctor`}
          />
          {isAuthenticated ? 
            <Cta 
              title={<Word value="Closest to you" />}
              subtitle={accountData ? `Your closest specialists ${accountData.postcode ? 'to postcode '+accountData.postcode : ''}` : null}
              icon="chevron_right"
              iconBg="blue"
              svg={<ClosestIcon />}
              svgBg="blue"
              isCentered
              isBordered
              link={`${match.url}/closest`}
            />
          : null}
          {isAuthenticated ? 
            <Cta 
              title={<Word value="Recently viewed" />}
              subtitle="Show recently viewed Doctors"
              icon="chevron_right"
              iconBg="blue"
              svg={<DoctorIcon />}
              svgBg="green"
              isCentered
              isBordered
              link={`${match.url}/recently-viewed`}
            />
        : null}
        </div>
      </PageContent>
    </>
  );
};

export default ReferPatientIndex;
